import { render, staticRenderFns } from "./Purchasenotes.vue?vue&type=template&id=a659b868&scoped=true&"
import script from "./Purchasenotes.vue?vue&type=script&lang=js&"
export * from "./Purchasenotes.vue?vue&type=script&lang=js&"
import style0 from "./Purchasenotes.vue?vue&type=style&index=0&id=a659b868&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a659b868",
  null
  
)

export default component.exports